import { apiClient } from '@utils/api-client';

import { AccountAuthPayload, AuthContext } from '@modules/base/auth';

/**
 * login
 */
type LoginResult = {
  account: AccountAuthPayload;
  succes: boolean;
};

export const login = async (
  email: string,
  password: string,
  captcha?: string,
) => {
  const response = await apiClient.request<LoginResult>({
    url: '/auth/authorize/login',
    method: 'POST',
    data: {
      email,
      password,
      captcha,
    },
  });
  return response.data;
};

export const logout = async () => {
  const response = await apiClient.request<{ success: boolean }>({
    url: '/auth/authorize/logout',
    method: 'GET',
  });
  return response.data;
};

/**
 * me
 */
type MeResult = AuthContext;

export const me = async (authToken?: string) => {
  const response = await apiClient.request<MeResult>({
    url: '/auth/authorize/me',
    method: 'GET',
    headers: {
      authorization: `Bearer ${authToken}`,
    },
  });
  return response.data;
};

type RefreshResult = { account: AccountAuthPayload; success: boolean };

export const refresh = async () => {
  const response = await apiClient.request<RefreshResult>({
    url: '/auth/session/refresh',
    method: 'GET',
  });
  return response.data;
};
